import { render, staticRenderFns } from "./SquareOption.vue?vue&type=template&id=6b605404&scoped=true&"
import script from "./SquareOption.vue?vue&type=script&lang=js&"
export * from "./SquareOption.vue?vue&type=script&lang=js&"
import style0 from "./SquareOption.vue?vue&type=style&index=0&id=6b605404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b605404",
  null
  
)

export default component.exports